import React from "react";
import "./Footer.css";
function Footer() {
  return (
    <div className="footer">
      <h1>Fast Fix</h1>
      <div className="footer_nav">
            <p>© 2022 Fast Fix! Online Platform - Development in progress!</p>
            <p>Privacy · Terms · Sitemap · Company Details</p>
           
      </div>
    </div>
  );
}

export default Footer;
